import { formatPresenceCalendarDate } from "@/lib/presenceDisplay";
import type { DeviceStructureLeaveImpact } from "@/types";

type PresenceImpactStayListProps = {
  items: DeviceStructureLeaveImpact["current"];
  className?: string;
};

/** Compact stay rows for structure-leave / room-change impact modals. */
export function PresenceImpactStayList({
  items,
  className = "space-y-2",
}: PresenceImpactStayListProps) {
  if (items.length === 0) {
    return null;
  }
  return (
    <ul className={className}>
      {items.map((stay) => (
        <li
          key={stay.id}
          className="rounded-lg border border-surface-200 bg-surface-50 px-3 py-2 text-[13px] text-surface-800"
        >
          <div className="font-medium text-surface-900">{stay.guest_name}</div>
          <div className="mt-0.5 text-surface-500">
            {formatPresenceCalendarDate(stay.arrival_date)}
            {" → "}
            {formatPresenceCalendarDate(stay.departure_date)}
          </div>
        </li>
      ))}
    </ul>
  );
}
